import { FunctionComponent } from 'react';
import '../../../css/PublicWhatWeDoPage.css';
import uiMapaImg from '../../../img/vdr-ui-mapa.jpg';
import { useNavigate } from 'react-router-dom';

const Component02: FunctionComponent = () => {
  const navigate = useNavigate();
  const goToMapPage = () => navigate('/public/ver-mapa');

  return (
    <div className='public-what-we-do-page-component-two-container vdr-wwd-doc'>
      <div className='vdr-section-head vdr-wwd-section-head'>
        <h2 className='public-what-we-do-page-title'>Mapa Interactivo de Redes Eléctricas</h2>
        <small>Visualización</small>
      </div>
      <figure style={{ margin: '0' }} className='public-what-we-do-page-component-img-container'>
        {/* Captura del mapa público rediseñado (Osorno, SAESA), en lugar de la interfaz antigua. */}
        <img
          src={uiMapaImg}
          alt='Mapa interactivo con los alimentadores de Osorno y los paneles de artefactos e información técnica'
          style={{ width: '100%', height: 'auto' }}
        />
        <figcaption className='public-what-we-do-page-component-img-caption'>
          Figura 1: Herramienta de mapa interactivo de redes (VisiónDERRED).
        </figcaption>
      </figure>
      <p className='public-what-we-do-page-text'>
        Nuestro mapa interactivo permite explorar visualmente la infraestructura de distribución de
        manera intuitiva. Con esta herramienta, puedes navegar por alimentadores, líneas y
        transformadores, obteniendo información detallada sobre cada componente.
      </p>
      <div className='public-what-we-do-page-component-two-content-with-image vdr-wwd-callout'>
        <div className='public-what-we-do-page-text-content'>
          <p className='public-what-we-do-page-text'>El mapa incluye capas para visualizar:</p>
          <ul className='public-what-we-do-page-list vdr-wwd-list--cols'>
            <li>Polígonos de alimentadores</li>
            <li>Transformadores (AT-MT y MT-BT)</li>
            <li>Líneas</li>
            <li>Postes</li>
            <li>Consumos</li>
            <li>Equipos de operación y control</li>
            <li>
              Recursos energéticos distribuidos (PMGD, Techos FV y equipos de generación no solar)
            </li>
          </ul>
        </div>
      </div>
      <p className='public-what-we-do-page-text'>
        Al hacer clic en cualquier elemento, puedes acceder a su información técnica, como posición
        geográfica, nivel de tensión, capacidad de diseño e impedancia.
      </p>
      <p className='public-what-we-do-page-text'>Otras funcionalidades incluyen:</p>
      <ul className='public-what-we-do-page-list'>
        <li>Zoom para acercarse a áreas específicas</li>
        <li>Posibilidad de arrastrar el mapa para explorar diferentes zonas</li>
        <li>Filtros avanzados para activar/desactivar la visualización de artefactos</li>
      </ul>
      <p className='public-what-we-do-page-text'>
        Estas herramientas facilitan la personalización de la vista, permitiéndote enfocarte en los
        elementos de interés y obtener información detallada de manera eficiente y práctica.
      </p>
      <div className='public-what-we-do-page-btn-container'>
        <button className='primary-button-style public-what-we-do-page-btn' onClick={goToMapPage}>
          Ver Mapa
          <span aria-hidden='true'>→</span>
        </button>
      </div>
    </div>
  );
};

export default Component02;
